<script>
import NtvLabel from '../Label';

export default NtvLabel;
</script>
